import "oasi-main-theme/dist/oasi-main-theme.css";
import "oasi-widgets/dist/index.css";
import "./index.scss";
import "cadesplugin-api/dist/cadesplugin_api.js";
import * as angular from 'angular';
import 'angular-animate';
import 'angular-cookies';
import 'angular-touch';
import 'angular-sanitize';
import 'angular-messages';
import 'angular-aria';
import 'angular-resource';
import 'angular-ui-bootstrap';
import 'angular-ui-router';
import 'isogd-dossier-rest';
import 'isogd-document-link-rest';
import 'angular-filter';
import 'oasi-widgets';
import 'oasi-cryptopro';
import 'oasi-bpm-rest';
import 'oasi-nsi-rest';
import 'isogd-solar-rest';
import 'isogd-file-rest';
import 'isogd-gis-rest';
import 'isogd-document-rest';
import 'jquery';
import 'ng-file-upload';
import 'jquery';

import { DocumentService } from "./services/DocumentService";
import { DocumentRequisitesEditComponent } from "./components/document/document-requisites/documentRequisitesEdit";
import { DocumentRequisitesViewComponent } from "./components/document/document-requisites/documentRequisitesView";
import { DocumentRegistrationEditComponent } from "./components/document/document-registration/documentRegistrationEdit";
import { DocumentRegistrationViewComponent } from "./components/document/document-registration/documentRegistrationView";
import { DocumentTerritoryEditComponent } from "./components/document/document-territory/documentTerritoryEdit";
import { DocumentTerritoryViewComponent } from "./components/document/document-territory/documentTerritoryView";
import { DocumentObjectEditComponent } from "./components/document/document-object/documentObjectEdit";
import { DocumentObjectViewComponent } from "./components/document/document-object/documentObjectView";
import { DocumentSpecificEditComponent } from "./components/document/document-specific/documentSpecificEdit";
import { DocumentSpecificViewComponent } from "./components/document/document-specific/documentSpecificView";
import { DocumentRequestEditComponent } from "./components/document/document-request/documentRequestEdit";
import { DocumentRequestViewComponent } from "./components/document/document-request/documentRequestView";
import { DocumentApproveEditComponent } from "./components/document/document-approve/documentApproveEdit";
import { DocumentApproveViewComponent } from "./components/document/document-approve/documentApproveView";
import { DocumentLinkEditComponent } from "./components/document/document-link/documentLinkEdit";
import { DocumentLinkViewComponent } from "./components/document/document-link/documentLinkView";
import { DocumentTepEditComponent } from "./components/document/document-tep/documentTepEdit";
import { DocumentTepViewComponent } from "./components/document/document-tep/documentTepView";
import { DocumentViewComponent } from "./components/document/documentView";
import { DocumentEditComponent } from "./components/document/documentEdit";
import { DictionaryModalComponent } from "./components/common/dictionaryModal";
import { DocumentOrganizationEditComponent } from "./components/document/document-organization/documentOrganizationEdit";
import { DocumentOrganizationViewComponent } from "./components/document/document-organization/documentOrganizationView";
import { DossierCandidatesComponent } from "./components/dossier/dossierCandidates";
import { DossierEditComponent } from "./components/dossier/dossierEdit";
import { DossierViewComponent } from "./components/dossier/dossierView";
import { LinkedDossiersComponent } from "./components/dossier/linkedDossiers";
import { NewDossierComponent } from "./components/dossier/newDossier";
import { SearchDossiersComponent } from "./components/dossier/searchDossiers";
import { LinkedDocumentsEditComponent } from './components/linkedDocuments/linked-documents-edit';
import { LinkedDocumentsViewComponent } from './components/linkedDocuments/linked-documents-view';
import { LinkedDocumentsComponent } from './components/linkedDocuments/linked-documents';
import { SearchCandidatesComponent } from './components/linkedDocuments/search-candidates';
import { SearchFilterComponent } from './components/linkedDocuments/search-filter';
import { SearchPaginationComponent } from './components/linkedDocuments/search-pagination';
import { SearchResultSortingComponent } from './components/linkedDocuments/search-result-sorting';
import { SearchResultComponent } from './components/linkedDocuments/search-result';
import { FileService } from './services/FileService';
import { CertificateInfoComponent } from './components/files/folder-tree/certificateInfo';
import { file } from './components/files/folder-tree/file';
import { folder } from './components/files/folder-tree/folder';
import { folderNavigator } from './components/files/folder-tree/navigator';
import { SelectObjectTypeController } from './components/files/folder-tree/selectObjectType';
import { SignFileController } from './components/files/folder-tree/signFile';
import { VerifyController } from './components/files/folder-tree/verify';
import { FilesViewComponent } from './components/files/files-view';
import { ConfirmController } from './components/common/confirmation';
import { FilesEditComponent } from './components/files/files-edit';
import { HistoryComponent } from './components/history/history';
import { GisEditComponent } from './components/gis/gis-edit';
import { GisViewComponent } from './components/gis/gis-view';
import { LogFileGldController } from './components/log-files/logFileDlg';
import { LogFilesComponent } from './components/log-files/logFiles';
import { RegistrationStatusComponent } from './components/registration-status/registrationStatus';
import { DocumentHeaderComponent } from './components/document-header/documentHeader';
import { LinkedDocumentService } from './services/LinkedDocumentService';

let module = angular.module('isogd.document', ['ngAnimate',
    'ngCookies',
    'ngTouch',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngResource',
    'ui.bootstrap',
    'ui.router',
    'angular.filter',
    'isogd.solar.rest',
    'isogd.dossier.rest',
    'isogd.document.link.rest',
    'oasi.bpm.rest',
    'oasi.nsi.rest',
    'isogd.file.rest',
    'isogd.gis.rest',
    'isogd.document.rest',
    'oasi.cryptopro',
    'oasi.widgets',
    'ngFileUpload'])
    .config(['blockUIConfig', blockUIConfig])
    .service('documentService', DocumentService)
    .service('linkedDocumentService', LinkedDocumentService)
    .service('fileService', FileService)
    .component('certificateInfo', CertificateInfoComponent)
    .component('file', file)
    .component('folder', folder)
    .component('navigator', folderNavigator)
    .component('documentRequisitesEdit', DocumentRequisitesEditComponent)
    .component('documentRequisitesView', DocumentRequisitesViewComponent)
    .component('documentRegistrationEdit', DocumentRegistrationEditComponent)
    .component('documentRegistrationView', DocumentRegistrationViewComponent)
    .component('documentTerritoryEdit', DocumentTerritoryEditComponent)
    .component('documentTerritoryView', DocumentTerritoryViewComponent)
    .component('documentObjectEdit', DocumentObjectEditComponent)
    .component('documentObjectView', DocumentObjectViewComponent)
    .component('documentSpecificEdit', DocumentSpecificEditComponent)
    .component('documentSpecificView', DocumentSpecificViewComponent)
    .component('documentRequestEdit', DocumentRequestEditComponent)
    .component('documentRequestView', DocumentRequestViewComponent)
    .component('documentApproveEdit', DocumentApproveEditComponent)
    .component('documentApproveView', DocumentApproveViewComponent)
    .component('documentLinkEdit', DocumentLinkEditComponent)
    .component('documentLinkView', DocumentLinkViewComponent)
    .component('documentTepEdit', DocumentTepEditComponent)
    .component('documentTepView', DocumentTepViewComponent)
    .component('documentView', DocumentViewComponent)
    .component('documentEdit', DocumentEditComponent)
    .component('documentOrganizationEdit', DocumentOrganizationEditComponent)
    .component('documentOrganizationView', DocumentOrganizationViewComponent)
    /*.component('dictionaryModal', DictionaryModalComponent)*/
    .component('dossierCandidates', DossierCandidatesComponent)
    .component('dossierEdit', DossierEditComponent)
    .component('dossierView', DossierViewComponent)
    .component('linkedDossiers', LinkedDossiersComponent)
    .component('newDossier', NewDossierComponent)
    .component('searchDossiers', SearchDossiersComponent)
    .component('linkedDocumentsEdit', LinkedDocumentsEditComponent)
    .component('linkedDocumentsView', LinkedDocumentsViewComponent)
    .component('linkedDocuments', LinkedDocumentsComponent)
    .component('searchCandidates', SearchCandidatesComponent)
    .component('searchFilter', SearchFilterComponent)
    .component('searchPagination', SearchPaginationComponent)
    .component('searchResultSorting', SearchResultSortingComponent)
    .component('searchResult', SearchResultComponent)
    .controller('SelectObjectTypeController', SelectObjectTypeController)
    .controller('SignFileController', SignFileController)
    .controller('VerifyController', VerifyController)
    .component('filesView', FilesViewComponent)
    .component('filesEdit', FilesEditComponent)
    .controller('ConfirmController', ConfirmController)
    .component('history', HistoryComponent)
    .component('gisEdit', GisEditComponent)
    .component('gisView', GisViewComponent)
    .controller('LogFileGldController', LogFileGldController)
    .component('logFiles', LogFilesComponent)
    .component('registrationStatus', RegistrationStatusComponent)
    .component('documentHeader', DocumentHeaderComponent);

function blockUIConfig(blockUIConfig: any) {
    blockUIConfig.autoBlock = false;
    blockUIConfig.message = '';
}


// WEBPACK FOOTER //
// ./src/index.ts